// extracted by mini-css-extract-plugin
export default {"table":"Table_table__frg+a","header":"Table_header__+HAQD","headerCell":"Table_headerCell__36OXQ","body":"Table_body__df1FQ","row":"Table_row__o-0Sy","cell":"Table_cell__+Cvf9"};